import "./App.css";
import { Route, BrowserRouter as Router, Switch } from "react-router-dom";
import Navbar from "./components/Navbar/Navbar";
import UserContextProvider from "./contexts/UserContext";
import { createMuiTheme, ThemeProvider } from "@material-ui/core";
import ErrorPage from "./pages/Error/Error";
import Dashboard from "./pages/Dashboard/Dashboard";
import TestRoutes from "./routes/TestRoutes";
import ThankYou from "./pages/ThankYou/ThankYou";
import LoginPage from "./pages/LoginPage/LoginPage";
import Rank from "./pages/Rank/Rank";
import RegisteredUsers from "./pages/RegisteredUsers/RegisteredUsers";
import TestAudio from "./pages/TestAudio/TestAudio";

const theme = createMuiTheme({
	typography: {
		fontFamily: "Poppins",
	},
	palette: {
		primary: {
			main: "#107be5",
		},
		secondary: {
			main: "#f4792a",
		},
	},
});

function App() {
	return (
		<UserContextProvider>
			<ThemeProvider theme={theme}>
				<Router>
					<Navbar />
					<Switch>
						<Route exact path="/" component={LoginPage} />
						<Route exact path="/dashboard" component={Dashboard} />
						<Route exact path="/check" component={TestAudio} />
						<Route path="/test" component={TestRoutes} />
						<Route path="/thanks" component={ThankYou} />
						<Route exact path="/regUsers" component={RegisteredUsers} />
						<Route exact path="/ranks" component={Rank} />
						<Route path="*" component={ErrorPage} />
					</Switch>
				</Router>
			</ThemeProvider>
		</UserContextProvider>
	);
}

export default App;
